(function($, window, document, undefined) {
	$(function() {
		/**
		 * Date of birth
		 */
		function dateOfBirth() {
			function createCookie(name, value, days) {
				let expires;

				if (days) {
					let date = new Date();
					date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
					expires = "; expires=" + date.toGMTString();
				} else {
					expires = "";
				}

				document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
			}

			// Date picker
			$("#birthdayPicker").birthdayPicker({
				maxAge: 100,
				minAge: 0,
				"dateFormat": "middleEndian",
				"monthFormat": "number",
				"placeholder": true,
				"defaultDate": false,
			});

			$(".age-verification-form").on("submit", function(e) {
				e.preventDefault();

				const $button = $(this).find("button[type='submit']");

				// Clear all validation messages
				const verificationMessages = $(".verification-messages");
				$(verificationMessages).empty();
				$(".age-verification-form").removeClass("age-verification-form_invalid");

				const verificationMonth = parseInt($(".birthMonth").val());
				const verificationDay = parseInt($(".birthDate").val());
				const verificationYear = parseInt($(".birthYear").val());
				const verificationError = $("<p class='verification-error'></p>");

				function isLeapYear(year) {
					const date = new Date(year, 1, 28);
					date.setDate(date.getDate() + 1);
					return date.getMonth() == 1;
				}

				function getAge(date) {
					const birthDate = new Date(date);
					const now = new Date();
					let years = now.getFullYear() - birthDate.getFullYear();

					birthDate.setFullYear(birthDate.getFullYear() + years);

					if (birthDate > now) {
						years--;
						birthDate.setFullYear(birthDate.getFullYear() - 1);
					}
					const days = (now.getTime() - birthDate.getTime()) / (3600 * 24 * 1000);

					return years + days / (isLeapYear(now.getFullYear()) ? 366 : 365);
				}

				let birthDate;

				if (verificationYear && verificationMonth && verificationDay) {
					birthDate = `${verificationYear}-${verificationMonth < 10 ? "0" + verificationMonth : verificationMonth}-${verificationDay < 10 ? "0" + verificationDay : verificationDay}`;
				}

				const age = Math.floor(getAge(birthDate));

				if (isNaN(age)) {
					$(verificationError).text("Please enter your birthdate.");
					$(verificationMessages).append(verificationError);
					$(".age-verification-form").addClass("age-verification-form_invalid");
					return;
				}

				if (age < 21) {
					$(verificationError).text("Sorry! You are not allowed to enter!");
					$(verificationMessages).append(verificationError);
					$(".age-verification-form").addClass("age-verification-form_invalid");
				} else {
					$button.attr("disabled", "disabled");

					if ($("#save-age").is(":checked")) {
						createCookie("save-age", "yes", 365);
					}

					$.ajax({
						url: kp_age.ajax,
						dataType: "json",
						type: "post",
						data: {
							action: "kp_deals_age_verified"
						},
						success: function(data) {
							if (data.success) {
								$(".popup_age-verification").removeClass("popup_visible");
							} else {
								console.log(data);
							}
						},
						error: function() {
							return false;
						},
						complete: function() {
							$button.removeAttr("disabled");
						}
					});
				}
			});
		}

		function init() {
			dateOfBirth();
		}

		init();
	});
})(jQuery, window, document);
